import React, { createContext, PropsWithChildren, useState } from 'react';

export interface IShouldLogoutContext {
	shouldLogOut: boolean;
	setShouldLogOut: (p: boolean) => void;
}

export const LogOutContext = createContext<IShouldLogoutContext>({
	shouldLogOut: false,
	setShouldLogOut: () => {},
});

export const LogOutContextProvider = ({ children }: PropsWithChildren<{}>) => {
	const [shouldLogOut, setShouldLogOut] = useState(false);

	return (
		<LogOutContext.Provider
			value={{
				shouldLogOut,
				setShouldLogOut,
			}}
		>
			{children}
		</LogOutContext.Provider>
	);
};
